import { DefaultPageLayout } from "features/core/DefaultPageLayout";
import { DiagnosticsSession } from "./DiagnosticsSessions";
import { selectDiagnosticsConfiguration } from "features/config/store/selectors";
import { useAppSelector } from "app/hooks";

export interface DiagnosticsProps {
    drawerWidth: number;
}

export function Diagnostics(props: DiagnosticsProps) {
    // configuration
    const diagnosticsConfiguration = useAppSelector(
        selectDiagnosticsConfiguration,
    );

    return (
        <DefaultPageLayout
            drawerWidth={props.drawerWidth}
            main={
                <>
                    {diagnosticsConfiguration && (
                        <>
                            <DiagnosticsSession
                                drawerWidth={props.drawerWidth}
                                diagnosticsConfiguration={
                                    diagnosticsConfiguration
                                }
                            />
                        </>
                    )}
                </>
            }
        />
    );
}
